<template>
  <div>
    <div class="xc_wrap">
      <div class="tip-content">
        <span
          >请浏览凯尔克一系列的产品手册，了解有关凯尔克产品规格和服务的更多信息</span
        >
      </div>

      <ul class="file-list">
        <li v-for="item in xcList" :key="item.id" class="file-item" @click="downloadPDF(item)">
          <div class="file-img">
            <img :src="item.image" alt="" />
          </div>
          <div>
            <span class="file-title" >{{
              item[`${currentLang.prefix}title`]
            }}</span>
          </div>
        </li>
      </ul>
    </div>
    <div class="sc_pagi">
      <el-pagination
        :current-page="page"
        background
        layout="prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { companyPdfList, getArticleList } from "@/utils/http.js";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      xcList: [],
      page: 1,
      total: 0
    };
  },

  computed: {
    ...mapGetters(["currentLang"])
  },
  created() {
    if (this.$route.query.page) {
      this.page = parseInt(this.$route.query.page);
    }
  },
  mounted() {
    // this.getProductNameList();
    this.fetchFileList();
  },
  methods: {
    fetchFileList() {
      const query = {
        cate_id: 38,
        page: this.page,
        limit: 12
      };
      getArticleList(query).then(res => {
        if (res.code === 1) {
          this.total = res.data.count;
          this.xcList = res.data.list;
        }
      });
    },

    getProductNameList() {
      companyPdfList({ page: this.page, limit: 15 }).then(res => {
        console.log(res);
        if (res.code === 1) {
          this.total = res.data.count;
          this.xcList = res.data.list;
        }
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      // this.getProductNameList()
      this.fetchFileList();
      this.$router.push({
        query: {
          ...this.$route.query,
          page: val
        }
      })
    },
    downloadPDF(item) {
      // 要下载的文件路径
      var fileUrl = item.files;
      // 创建一个隐藏的<a>元素，用于下载文件
      var a = document.createElement("a");
      a.href = fileUrl;
      // a.download = item[`${this.currentLang.prefix}title`]; // 可以自定义下载文件的名称
      a.target = "_blank";
      a.style.display = "none";
      // 将<a>元素添加到页面上
      document.body.appendChild(a);
      // 触发点击事件，开始下载
      a.click();
      // 下载完成后，移除<a>元素
      document.body.removeChild(a);
    }
  }
};
</script>
<style lang="scss" scoped>
.xc_wrap {
  width: 1200px;
  height: auto;
  margin: 50px auto;

  .tip-content {
    width: 100%;
    margin-bottom: 40px;
    text-align: center;
    font-size: 18px;
    color: #333;
  }

  ul.file-list {
    width: 1200px;
    flex-wrap: wrap;
    display: flex;
  }

  li.file-item {
    width: 386px;
    height: auto;
    background: #f5f5f5;
    margin: 0 20px 20px 0;
    padding: 0 0 20px;
    cursor: pointer;

    .file-img {
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      width: 100%;
      height: 386px;
      background: linear-gradient(
        to bottom,
        #f5f5f5,
        #f5f5f5,
        rgba(0, 0, 0, 0.15)
      );
    }

    .file-img img {
      width: 300px;
      height: 360px;
      object-fit: cover;
      box-shadow: 4px 4px 10px 0px rgba(0, 0, 0, 0.4);
    }

    .file-title {
      margin: 15px 25px 0;
      font-size: 18px;
      font-weight: 500;
      color: #063358;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }

  li.file-item:nth-child(3n) {
    margin-right: 0;
  }
}
.sc_pagi {
  width: 500px;
  margin: 0 auto 50px;
  display: flex;
  justify-content: center;
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #e8363e;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cpzy/information.vue